import { DOMAIN_MAPPINGS } from './constants/domain-redirect-constants';
import type {
  LocationInfo,
} from './types/domain-redirect-types';

export function getRedirectUrl(location: LocationInfo): string | null {
  const newHost = DOMAIN_MAPPINGS[location.hostname];

  if (!newHost) {
    return null;
  }

  return `${location.protocol}//${newHost}${location.pathname}${location.search}${location.hash}`;
}

export function handleDomainRedirect(): void {
  const redirectUrl = getRedirectUrl(window.location);

  if (redirectUrl) {
    // Use replace to avoid adding old URL to browser history
    window.location.replace(redirectUrl);
  }
}

